module.exports = __webpack_public_path__ + "img/ExhibitSpecialLeftBottom.d4159ba8.png";